// extracted by mini-css-extract-plugin
export default {"modifier":"Modifiers_modifier__TGWg5","description":"Modifiers_description__3VRro","control":"Modifiers_control__1-Yc2","wideInput":"Modifiers_wideInput__BvZ10"};